// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1mcJh","contentWrap":"_3kO-d","secondSectionWrap":"_1Eqy1","bottomWrapper":"_2VT1u","howItWorksWrap":"_2xLIu","congratsRatingOuter":"_2k_1J","customerCareWrap":"_2xE7i"};